// extracted by mini-css-extract-plugin
module.exports = {"expandable-container":"styles_expandable-container__3mgg0","expandableContainer":"styles_expandable-container__3mgg0","header":"styles_header__WpwVO"};